export const userProfileConstants = {
  ARTICLE_LIST_IMAGE_WIDTH: 200,
};
